/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const cdc = {
  reconsent: {
    dialog: {
      title: 'Conclusão de perfil',
      description: 'No entanto, precisamos do seu consentimento para o seguinte',
    },
  },
};
